import { Injectable } from '@angular/core';

@Injectable()
export class BrowserControlCommunicationService {
  drilldownEnabled = false;
  embeddedInXsellerator = false;
  disableRippleEffect = false;
  hasError = false;
  newDms = false;

  constructor() {
    // newDms is a query parameter added to the URL when we are using the new Dms.
    // We can disable drilldown in this case (not required in new Dms), but we need to know if we are embedded in Xsellerator.
    const params = new URLSearchParams(window.location.search);
    this.newDms = params.get('newDms')?.toLowerCase() === 'true';
    if (this.newDms) {
      this.drilldownEnabled = false;
      this.embeddedInXsellerator = true;
    } else {
      if ((<any>window).DrilldownManager || this.getSyncHostObject('DrilldownManager')) {
        this.drilldownEnabled = true;
        this.embeddedInXsellerator = true;
        this.disableRippleEffect = true;
      }
    }
  }

  drilldown(name: string, pbWindow: string, params: string[]) {
    if (this.drilldownEnabled) {
      const paramsString: string = params.join('+');

      const drilldownManager = this.getSyncHostObject('DrilldownManager');
      if (drilldownManager) {
        drilldownManager.drilldown(name, pbWindow, paramsString);
      } else {
        (<any>window).DrilldownManager.drilldown(name, pbWindow, paramsString);
      }
    }
  }

  getSilentLoginToken() {
    const connectionInfo = this.getSyncHostObject('ConnectionInfo');
    if (connectionInfo) {
      return connectionInfo.getToken();
    } else {
      return (<any>window).ConnectionInfo.getToken();
    }
  }

  /**
   * Reads a named WebView2 host object off `chrome.webview.hostObjects.sync`.
   *
   * `sync` is a Proxy: simply reading a property triggers a synchronous round-trip
   * to the host. When the requested host object is not registered, WebView2 throws
   * `Error: No parameters in result: { ... "parameters": null ... }`. Optional chaining
   * does not protect against this — `sync` itself is defined, so the throw happens
   * inside the proxy's getter. Treat a missing/unregistered host object as absent.
   */
  // Return type is `any`: WebView2 host objects are untyped dynamic proxies.
  private getSyncHostObject(name: string): any {
    const sync = (<any>window).chrome?.webview?.hostObjects?.sync;
    if (!sync) {
      return undefined;
    }
    try {
      return sync[name];
    } catch {
      return undefined;
    }
  }

  receivePowerBuilderMessage() {
    let promise = new Promise((resolve, reject) => {
      (<any>window).injectIntoAngular = (messageObject: any) => {
        resolve(messageObject);
      };
    });

    return promise;
  }
}
